import React from 'react'
import ReactGA from 'react-ga'
import { browserHistory, Link } from 'react-router' 
import classes from './GameList.scss'
import GameItem from './GameItem'
// import ReactSVG from 'react-svg'
import 'whatwg-fetch'

const DEFAULT_GUESS = '(none)'

class Games extends React.Component {

  constructor (props) {
    super(props)

    const self: any = this
    self.state = { games: [], oldGames: [], loadingNew: false, loadingOld: false, starting: false }
    self.fetchGames = self.fetchGames.bind(self)
    self.renderHeaders = self.renderHeaders.bind(self)
    self.renderGame = self.renderGame.bind(self)
    self.newChallenge = self.newChallenge.bind(self)
    self.newGame = self.newGame.bind(self)
    self.loadOldGames = self.loadOldGames.bind(self)
  }

  componentWillMount () {
    const { baseUrl, type } = this.props
    if (!baseUrl || !type) return
    this.fetchGames(baseUrl, type)
  }

  componentWillReceiveProps (nextProps) {
    const { baseUrl, type } = nextProps
    if (!baseUrl || !type) return
    this.fetchGames(baseUrl, type)
  }

  fetchGames (baseUrl, type) {
    this.setState({ loadingNew: true })
    fetch(`${baseUrl}/games`, {
      method: 'POST',
      body: JSON.stringify({ type, age: 'new' }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          this.setState({ games: res.games })
        } else {
          // console.log(res)
          // alert(res.err || res.message || res.msg)
        }
        this.setState({ loadingNew: false })
      })
  }

  resumeGame (gameId) {
    browserHistory.push(`/game/${gameId}`)
  }

  renderGame (game, idx) {
    const { baseUrl, type } = this.props
    if (type === 'solo') {
      return (
        <GameItem key={idx} id={game.id} first={game.score} second={game.timeAgo} third={game.guess || DEFAULT_GUESS} onClick={() => this.resumeGame(game.id)} baseUrl={baseUrl} won={game.won} lost={game.forfeit} />
      )
    } else {
      let won
      let lost
      let waiting = false
      if ((game.won || game.forfeit) && (game.enemyWon || game.enemyForfeit)) {
        waiting = !game.enemyWon && !game.enemyForfeit
        won = !waiting && !game.forfeit && (game.won && (game.score >= game.enemyScore) || game.enemyForfeit)
        lost = !waiting && (game.forfeit || (game.score < game.enemyScore && !game.enemyForfeit))
      }
      return (
        <GameItem key={idx} id={game.id} first={game.opponent} second={game.score} third={game.enemyScore} fourth={game.timeAgo} fifth={game.guess || DEFAULT_GUESS} onClick={() => this.resumeGame(game.id)} baseUrl={baseUrl} won={won} lost={lost} />
      )
    }
  }

  renderGames (games) {
    return games.map((g, i) => this.renderGame(g, i))
  }

  newGame () {
    const { baseUrl, username } = this.props
    const { starting } = this.state

    if (starting) return

    if (!username) {
      browserHistory.push('/game')
    } else {
      this.setState({ starting: true })
      fetch(`${baseUrl}/games/new`, { credentials: 'include' })
       .then(res => res.json())
       .then(res => {
         const { gameId } = res
         this.setState({ starting: false })
         if (username) {
           browserHistory.push(`/game/${gameId}`)
         }
         ReactGA.event({ category: 'Game', action: 'Started game' })
       })
       .catch(err => {
         this.setState({ starting: false })
         console.log('error starting game: ', err)
       })
    }
  }

  newChallenge () {
    const { username } = this.props
    if (username) {
      browserHistory.push('/challenges/new')
    } else {
      alert('You must be logged in to issue a challenge')
    }
  }

  loadOldGames () {
    const { baseUrl, type } = this.props

    this.setState({ loadingOld: true })
    fetch(`${baseUrl}/games`, {
      method: 'POST',
      body: JSON.stringify({ type, age: 'old' }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          this.setState({ oldGames: res.games })
        } else {
          // console.log(res)
          // alert(res.err || res.message || res.msg)
        }
        this.setState({ loadingOld: false })
      })
  }

  renderHeaders (old = false) {
    const { type } = this.props
    if (type === 'solo') {
      return (<ul className={classes.headers}>
        <li>Score</li>
        <li>Last play</li>
        <li>{old ? 'Target' : 'Last guess'}</li>
      </ul>)
    } else {
      return (<ul className={classes.headers}>
        <li>Opponent</li>
        <li>My score</li>
        <li>Opponent score</li>
        <li>Last play</li>
        <li>{old ? 'Target' : 'Last guess'}</li>
      </ul>)
    }
  }

  render () {
    const { username, type } = this.props
    const { games, oldGames, loadingNew, loadingOld, starting} = this.state
    // const loadingClasses = [classes.loadingIcon, !loadingNew && classes.hidden].join(' ')
    const newGameClasses = [classes.newGame, starting && classes.disabled].join(' ')
    return (
      <div>
        {username && this.renderHeaders()}
        {!username && <h3 className={classes.emptyText}>You must be <Link to='/' style={{borderBottom: '1px solid #fff', paddingBottom: '0.1px'}}>logged in</Link> to save games</h3>}
        {!loadingNew && username && games.length < 1 && <h3 className={classes.emptyText}>No games :(</h3>}
        {username && loadingNew && <h3 className={classes.loading}>Loading...</h3>}
        <ul className={classes.gameItems}>{this.renderGames(games)}</ul>
        {type === 'solo' && <span onClick={this.newGame} className={newGameClasses}><i className="fa fa-plus-square" aria-hidden="true"></i>Start New Game</span>}
        {type === 'multi' && <span onClick={this.newChallenge} className={classes.newGame}><i className="fa fa-plus-square" aria-hidden="true"></i>New Challenge</span>}
        {!loadingOld && oldGames.length === 0 && <p className={classes.viewOld} onClick={this.loadOldGames}>View old games</p>}
        {loadingOld && <h3 className={classes.loading}>Loading...</h3>}
        {oldGames.length > 0 && this.renderHeaders(true)}
        <ul className={classes.gameItems}>{this.renderGames(oldGames)}</ul>
      </div>
    )
  }
}

export default Games



/** WEBPACK FOOTER **
 ** ./src/components/GameList/Games.js
 **/